
namespace GeniuzPOS.Inventory {

    @Serenity.Decorators.registerClass()
    export class IcStockSoldDtDialog extends Serenity.Extensions.GridEditorDialog<IcStockSoldDtRow> {
        protected getFormKey() { return IcStockSoldDtForm.formKey; }
        // protected getIdProperty() { return IcStockSoldDtRow.idProperty; }
        protected getLocalTextPrefix() { return IcStockSoldDtRow.localTextPrefix; }
        protected getNameProperty() { return IcStockSoldDtRow.nameProperty; }
        // protected getService() { return IcStockSoldDtService.baseUrl; }
        // protected getDeletePermission() { return IcStockSoldDtRow.deletePermission; }
        // protected getInsertPermission() { return IcStockSoldDtRow.insertPermission; }
        // protected getUpdatePermission() { return IcStockSoldDtRow.updatePermission; }

        protected form = new IcStockSoldDtForm(this.idPrefix);

        public qnNo: number;
        public purprice: number;
        public StkUnitT: string;
      

        constructor() {
            super();

            this.form = new IcStockSoldDtForm(this.idPrefix);
            this.form.SkuCode.changeSelect2(e => {
                var skucode = Q.toId(this.form.SkuCode.value);
                if (skucode != null) {

                    // this.StkUnitT = Product.CsSkuRow.getLookup().itemById[skucode].StkUnit;
                    // this.form.PurUnit.value = Product.CsSkuRow.getLookup().itemById[skucode].StkUnit;
                    // this.form.PurUnitRatio.value = 1;
                    this.form.UnitChange.set_value("0");
                    // this.form.ItemRemark.value = Product.CsSkuRow.getLookup().itemById[skucode].SkuDesc + " X" + this.form.PurUnitRatio.value.toString() + " " + this.StkUnitT;


                }
            });
            this.form.UnitChange.element.parent();
            this.form.UnitChange.change(e => {
                var skucode = Q.toId(this.form.SkuCode.value);
                var sku :string = this.form.SkuCode.value
                var stku = this.StkUnit;
                var puru = this.PurUnit;
                if (skucode != null) {
                    if (!puru) {
                        this.StkUnitT = Product.CsSkuRow.getLookup().itemById[sku].StkUnit;
                        this.form.PurUnit.value = Product.CsSkuRow.getLookup().itemById[sku].PurUnit;
                        this.form.PurUnitRatio.value = Product.CsSkuRow.getLookup().itemById[sku].PurUnitRatio;
                        this.form.ItemRemark.value = Product.CsSkuRow.getLookup().itemById[sku].SkuDesc + " (X" + this.form.PurUnitRatio.value.toString() + " " + this.StkUnitT+")"+this.form.PurUnit.value;
                    } 
                    
                    else if (!stku) {
                        this.StkUnitT = Product.CsSkuRow.getLookup().itemById[sku].StkUnit;
                        this.form.PurUnit.value = Product.CsSkuRow.getLookup().itemById[sku].StkUnit;
                        this.form.PurUnitRatio.value = 1;
                        this.form.UnitChange.set_value("0");
                        this.form.ItemRemark.value = Product.CsSkuRow.getLookup().itemById[sku].SkuDesc + " X" + this.form.PurUnitRatio.value.toString() + " " + this.StkUnitT;

                    }

                }
            });

            this.form.CostValue.change(e => {
                var skucode = Q.toId(this.form.SkuCode.value);
                var q = Q.toId(this.form.Qty.value)
                if (skucode != null) {

                    if (q = 0) {
                        this.form.PurUnitPrice.value = (this.form.CostValue.value || 0) / 1;
                    } else {
                        this.form.PurUnitPrice.value = (this.form.CostValue.value || 0) / (this.form.Qty.value || 1);
                    }

                }
            });


            this.form.PurUnitPrice.change(e => {
                var skucode = Q.toId(this.form.SkuCode.value);
                if (skucode != null) {


                    this.form.CostValue.value = (this.form.PurUnitPrice.value || 0) * (this.form.Qty.value || 0);


                }
            });


            this.form.Qty.change(e => {
                var skucode = Q.toId(this.form.SkuCode.value);
                if (skucode != null) {


                    this.form.CostValue.value = (this.form.PurUnitPrice.value || 0) * (this.form.Qty.value || 0);


                }
            });

        }
        private get StkUnit() {
            return this.form.UnitChange.value != "0";
        }
        private get PurUnit() {
            return this.form.UnitChange.value != "1";
        }
        protected getToolbarButtons(): Serenity.ToolButton[] {
            let buttons = super.getToolbarButtons();

            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "save-and-close-button"), 1);
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "apply-changes-button"), 1);
           
         
            let newBtn: Serenity.ToolButton =
            {
                title: "บันทึกและสร้างรายการถัดไป",
                hint: "Save and new",
                separator: false,
                cssClass: "button-saveandnew",
                icon: "fa fa-save",
                hotkey: 'alt+s',
                onClick: (e) => {

                    if(this.form.Qty.value == null){
                        this.form.Qty.value = 0
                    }
                    
                    e.preventDefault();
                    this.saveAndNew();
                }
            };
            buttons.push(newBtn);
            
            buttons.push(
                {
                    title: Q.text("Close"),	// *** Get button text from translation
                    cssClass: '.panel-titlebar-close',
                    icon: 'fa-close',
                    hint: 'esc',
                    hotkey: 'esc',
                    onClick: () => {
                        this.dialogClose();
                        // *** do something on click if you want **

                    },
                }
            );

            return buttons;
        }
        private saveAndNew() {
            let e = this.entity; let f = this.form;
            this.save((response) => {
                let ent: IcStockSoldDtRow = { SkuCode: e.SkuCode };
                this.loadEntity(ent);
            });
        }
        protected beforeLoadEntity() {
            let self = this;
            self.toolbar.findButton('save-and-close-button').text('บันทึกรายการ');
            self.toolbar.findButton('delete-button').text('ลบรายการ');

            let nbrRetry = 0;
            (function changeTitle() {
                if (nbrRetry >= 10) {
                    return;
                }

                setTimeout(() => {
                    if ((self as any).isMarkedAsPanel === true) {
                        if (self.element.find(".ui-dialog-title").length == 1) {
                            self.element.find(".ui-dialog-title").html("");
                            self.element.find(".ui-dialog-titlebar-text").html("");
                            self.element.find(".ui-dialog-titlebar-close").html("");//panel-titlebar
                        }
                        else {
                            changeTitle();
                        }
                    }
                    else {
                        if (self.element.parent().find(".ui-dialog-title").length == 1) {
                            self.element.parent().find(".ui-dialog-title").html("");
                            self.element.parent().find(".ui-dialog-titlebar-text").html("");
                            self.element.parent().find(".ui-dialog-titlebar-close").html("");
                        }
                        else {
                            changeTitle();
                        }
                    }
                }, 10);
            })();
           
        }

        protected afterLoadEntity() {
            super.afterLoadEntity();
            var thisId = Q.toId(this.form.Id.value);
            if (thisId < 0) {
                let self = this;
                self.toolbar.findButton('button-saveandnew').toggleClass('disabled', true);
            }
        }
        protected getCssClass() {
            super.getCssClass();
            return "fixRight";
            
        }

    }
}